var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapRoute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.22,62.41h0v-13.4h5.45v13.39h0c.33,0-.01,0,0,0h0l17.33,.02L42.1,1.6h-7.42V13.31h-5.45V1.58h-7.3L11.99,62.4H29.22Zm0-45.66h5.45v13.39h-5.45v-13.39Zm0,15.46h5.45v13.39h-5.45v-13.39Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapRoute);
export default __webpack_public_path__ + "static/media/map_route.1e00f7eaf8eed8df3158424251629f39.svg";
export { ForwardRef as ReactComponent };